// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
function IconArrowLeft(Props) {
  var className = Props.className;
  var tmp = {
    height: "19",
    width: "21",
    fill: "none",
    viewBox: "0 0 21 19",
    xmlns: "http://www.w3.org/2000/svg"
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement("svg", tmp, React.createElement("path", {
    d: "M20.9531 9.95336C20.9531 10.6096 20.4375 11.1252 19.8281 11.1252H3.89062L10.125 17.0315C10.5938 17.4534 10.5938 18.2034 10.1719 18.6252C9.75 19.094 9.04688 19.094 8.57812 18.6721L0.328125 10.7971C0.09375 10.5627 0 10.2815 0 9.95336C0 9.67211 0.09375 9.39086 0.328125 9.15648L8.57812 1.28148C9.04688 0.859606 9.75 0.859606 10.1719 1.32836C10.5938 1.75023 10.5938 2.50023 10.125 2.92211L3.89062 8.82836H19.8281C20.4844 8.82836 20.9531 9.34398 20.9531 9.95336Z",
    fill: "currentColor"
  }));
}
IconArrowLeft.displayName = "IconArrowLeft";
var make = IconArrowLeft;
export { make };
/* react Not a pure module */